import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  const activities = [
    {
      icon: 'ri-code-box-line',
      title: 'Développement de logiciels sur mesure',
      description: 'Création d\'applications personnalisées adaptées aux besoins spécifiques de chaque client',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Conception de solutions informatiques',
      description: 'Analyse et conception de systèmes informatiques performants et évolutifs',
    },
    {
      icon: 'ri-server-line',
      title: 'Installation et configuration de serveurs',
      description: 'Mise en place d\'infrastructures serveurs sécurisées et optimisées',
    },
    {
      icon: 'ri-tools-line',
      title: 'Maintenance et support informatique',
      description: 'Assistance technique continue et résolution de problèmes informatiques',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="pt-32 pb-20 px-6 lg:px-8 bg-gradient-to-br from-blue-50 via-white to-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center px-4 py-2 rounded-full border border-blue-600 bg-white mb-6">
              <span className="text-sm font-medium text-blue-600">À propos</span>
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              Expertise informatique à Toulouse
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Une activité indépendante spécialisée dans la programmation informatique et les services IT
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/f5a2990f262ed8e438f70cbaad45ebb9.jpg"
                alt="Rafal Jozef Szelenc"
                className="w-full h-auto rounded-2xl shadow-2xl object-cover"
              />
            </div>

            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Rafal Jozef Szelenc
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Rafal Szelenc IT Services est une activité indépendante spécialisée dans la programmation informatique et les services IT, basée à Toulouse.
              </p>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                L'entreprise est dirigée par Rafal Jozef Szelenc, ingénieur informatique spécialisé dans le développement logiciel et les infrastructures informatiques.
              </p>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Rafal a étudié l'informatique à l'Université Jagellonne de Cracovie, l'une des universités les plus reconnues de Pologne.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Grâce à ses compétences techniques, il accompagne les entreprises et particuliers dans la création de solutions informatiques performantes.
              </p>

              <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-r-lg">
                <p className="text-base text-gray-700 font-medium">
                  L'objectif est de fournir des solutions fiables, sécurisées et adaptées aux besoins de chaque client.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Nos activités
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Des services complets pour répondre à tous vos besoins informatiques
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {activities.map((activity, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-xl border border-gray-200 hover:border-blue-600 transition-all duration-300 shadow-sm hover:shadow-lg"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-lg mb-6">
                  <i className={`${activity.icon} text-3xl text-blue-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{activity.title}</h3>
                <p className="text-base text-gray-600 leading-relaxed">{activity.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Informations légales
              </h2>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-building-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <p className="font-semibold text-gray-900">Entreprise</p>
                    <p className="text-gray-600">Rafal Szelenc IT Services</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-user-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <p className="font-semibold text-gray-900">Propriétaire</p>
                    <p className="text-gray-600">Rafal Jozef Szelenc</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-file-text-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <p className="font-semibold text-gray-900">SIRET</p>
                    <p className="text-gray-600">102 261 021 00012</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-map-pin-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <p className="font-semibold text-gray-900">Adresse</p>
                    <p className="text-gray-600">73 Rue Fieux<br />31100 Toulouse<br />France</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-blue-600 p-12 rounded-2xl text-white">
              <h3 className="text-3xl font-bold mb-6">
                Prêt à démarrer votre projet ?
              </h3>
              <p className="text-lg mb-8 text-white/90">
                Contactez-nous pour discuter de vos besoins informatiques et découvrir comment nous pouvons vous aider.
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Nous contacter
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}